import { Badge } from '@frontend/shadcn/components/ui/badge';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { ChevronRight, CircleIcon, Gift, Trophy } from 'lucide-react';
import React from 'react';

export const RefreshMainLayoutBoost = (): JSX.Element => {
  return (
    <Card className="border-grey-2 flex w-full flex-col rounded-2xl border border-solid bg-white">
      <CardContent className="p-4">
        <div className="flex w-full items-start gap-4">
          <div className="flex h-[54px] w-[54px] items-center justify-center rounded-2xl bg-magenta-4">
            <Gift className="h-6 w-6 text-white" />
          </div>
          <div className="flex flex-1 items-center gap-4 self-stretch">
            <div className="flex flex-1 flex-col gap-1">
              <div className="flex w-full flex-col">
                <div className="flex w-full items-center justify-between">
                  <div className="text-grey-6 font-medium">
                    Free product worth $200
                  </div>
                  <div className="flex items-center gap-2.5">
                    <Badge className="flex items-center gap-1 rounded-lg bg-green-4 px-2 py-0.5 text-white">
                      <Trophy className="h-3 w-3" />
                      <span className="text-xs">Claimed</span>
                    </Badge>
                    <ChevronRight className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-grey-5 text-xs">
                    Reward on first conversion
                  </span>
                  <CircleIcon className="text-grey-3 h-3 w-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default RefreshMainLayoutBoost;
